// src/views/Support/SupportPage.jsx
//
// Ayuda. No es configuración —no ajusta nada— así que no vive en ninguno de los
// tres alcances; y tampoco es un objeto de la app, así que no es un destino del
// rail como Agents o Workflows. Es una utilidad, y por eso el rail la pinta
// abajo, junto al avatar, separada de los sustantivos.
//
// La vista es la que ya existía en `/user/support`; lo único que cambia es que
// deja de ser una sección de una pantalla que decía ser tu perfil.
import React, { useContext } from 'react';
import AppBackdrop from '../../components/ui/AppBackdrop';
import AuthContext from '../../AuthContext';
import SupportView from '../Profile/SupportView';

export default function SupportPage() {
  const { user } = useContext(AuthContext);

  return (
    <section className="relative min-h-screen overflow-hidden bg-gray-950 text-white">
      <AppBackdrop />
      {/* El desplazamiento sale de --rail-w, no de un número fijo: el rail se
          pliega y las vistas tienen que seguirlo. */}
      <div className="relative z-10 rail-pad p-6 md:p-8">
        <div className="mx-auto w-full max-w-5xl">
          <SupportView userId={user?.id || user?.user_id} />
        </div>
      </div>
    </section>
  );
}
